if (!customElements.get("td-accordion")) {
    class TDAccordion extends HTMLElement {
        constructor() {
            super()
            this.TOGGLE_CLASS = '.accordion-toggle'
            this.CONTENT_CLASS = '.accordion-content'
            this.ACTIVE_IMAGE_CLASS = '.accordion-toggle-image'
            this.SOLDOUT_CLASS = 'soldout'
            this.IS_CHILD = this.dataset.child || null
            this.ALWAYS_OPEN = this.dataset.alwaysOpen || null

            this.accordionToggle = this.querySelector(this.TOGGLE_CLASS)
            this.accordionActiveImage = this.querySelector(this.ACTIVE_IMAGE_CLASS)
            this.accordionContent = this.querySelector(this.CONTENT_CLASS)
            this.options = this.querySelectorAll('li')
            this.activeOption = null
        }
    
        connectedCallback() {
            if (this.accordionToggle) {
                if (this.ALWAYS_OPEN) {
                    this.accordionToggle.classList.toggle('active')
                    this.accordionContent.classList.toggle('active')
                    this.accordionContent.style.maxHeight = this.accordionContent.scrollHeight + "px"
                } else {
                    this.accordionToggle.addEventListener('click', () => {
                        this.accordionToggle.classList.toggle('active')
                        this.accordionContent.classList.toggle('active')
                    
                        if (this.accordionContent.classList.contains('active')) {
                            this.accordionContent.style.maxHeight = this.accordionContent.scrollHeight + "px"
                            if (!this.IS_CHILD) {
                                setTimeout(() => {
                                    this.accordionContent.style.maxHeight = "2000px"
                                  }, 400);
                            }
                        } else {
                            this.accordionContent.style.maxHeight = 0
                        }
                    });
                }
            }
            if (this.options.length > 0 && this.IS_CHILD) {
                this.options.forEach((option) => {
                    option.addEventListener('click', () => {
                        let value = option.querySelector('input').value
                        let imgSrc = option.querySelector('img').src
                        let isDisabled = option.classList.contains(this.SOLDOUT_CLASS)

                        if (this.activeOption != value && !isDisabled) {
                            this.activeOption = value
                            this.activeImg = imgSrc

                            if (this.activeOption && this.activeImg) {
                                // this.setActive()
                            }
                        }
                    })
                })
            }
        }

        setActive() {
            this.accordionActiveImage.src = this.activeImg
            this.accordionActiveImage.style.display = "block"
            this.accordionToggle.querySelector('span').textContent = this.activeOption
        }
    }

    customElements.define("td-accordion", TDAccordion)
}